/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-return-assign */
import { sprintf } from 'sprintf-js'
import format from 'date-fns/format'
import Decimal from 'decimal.js'

export function renderRoute(
  roles,
  permissions,
  options = { all: false },
  permissionUser = []
) {
  const result = roles?.filter(
    role =>
      permissions.find(x => x.name === role) ||
      permissionUser.find(x => x.name === role)
  )
  if (!options.all) return result.length !== 0

  return result.length === roles.length
}

export function renderRouteEmail(emails, user) {
  const result = emails?.filter(email => user?.email === email)

  return result.length !== 0
}

export function getDecimalPart(money) {
  if (!money) return '00'

  if (typeof money == 'string') {
    const moneyString = Number(money)?.toFixed(2)

    const decimalPart = moneyString.split('.')[1]

    return decimalPart || '00'
  }

  const moneyString = money?.toFixed(2)

  const decimalPart = moneyString.split('.')[1]

  return decimalPart || '00'
}

export function getIntegerPart(number) {
  if (!number) return '0'

  if (typeof number == 'string') {
    const numberString = Number(number)?.toFixed(2)

    const integerPart = numberString.split('.')[0]

    return integerPart || '00'
  }

  const numberString = number?.toFixed(2)

  const integerPart = numberString.split('.')[0]

  return integerPart || '00'
}

export function renderRouteRole(roles, userRoles) {
  const result = roles?.filter(role =>
    userRoles?.find(x => x.name.includes(role))
  )

  return result.length !== 0
}

export function renderRoutePermissions(
  permissions = [''],
  userPermissions = [{ name: '' }]
) {
  const result = permissions?.filter(role =>
    userPermissions?.find(x => x.name.includes(role))
  )

  return result.length !== 0
}

export function convertBytesToMbs(Bytes) {
  return `${Bytes / 1000000} Megabytes`
}

export function dateFormated(data) {
  const date = new Date(`${data} 00:00:00`)

  return date.toLocaleDateString('en-us')
}

const formatter = new Intl.DateTimeFormat('pt-BR')

export function dateFormatedPT(data) {
  let date = null
  if (data) {
    if (data.length <= 10) {
      date = new Date(`${data} 10:00:00`)
    } else {
      date = new Date(`${data}`)
    }
    date = formatter.format(date)
  }

  return date
}

export function dateFormatedFullDate(data) {
  if (data) {
    return format(new Date(data), "dd/MM/yyyy 'às' HH:mm:ss")
  }

  return null
}

export function duplicateTime(times, multiply) {
  let allSeconds = 0
  let totalMinutes = 0

  times.forEach(time => {
    const [hour, minute, second] = time.split(':')

    allSeconds += hour * 3600
    allSeconds += minute * 60
    allSeconds += second * 1
  })

  allSeconds *= multiply

  totalMinutes = Math.floor(allSeconds / 60)
  const seconds = allSeconds % 60
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  return sprintf('%02d:%02d:%02d', hours, minutes, seconds)
}

export function exportFormatedMoney(money) {
  if (isNaN(money)) return money
  return parseFloat(money).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
}

export function applyDiscount(value, discount) {
  return value - value * (discount / 100)
}

export function cpfMask(value) {
  const remove = value.replace(/[^\d]/g, '')

  if (remove?.length > 11) {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  }
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export function phoneMask(value) {
  return value
    .replace(/\D/g, '') // remove tudo que não for número
    .replace(/^(\d{2})(\d)/, '($1) $2') // adiciona parênteses no DDD
    .replace(/(\d{4,5})(\d{4})$/, '$1-$2') // coloca o traço no final (se for 8 ou 9 dígitos)
}

export function removeEmpty(obj) {
  return Object.entries(obj).reduce(
    (a, [k, v]) => (v ? ((a[k] = v), a) : a),
    {}
  )
}

export function returnFirstLetters(name) {
  let final = ''

  for (let i = 0; i < name.length; i++) {
    if (final.length === 2) break

    if (i === 0) {
      final += name[i]
    }
    if (name[i] === ' ') {
      final += name[i + 1]
    }
  }

  return final
}

export function toFixed(num, fixed) {
  const re = new RegExp(`^-?\\d+(?:.\\d{0,${fixed || -1}})?`)
  return num.toString().match(re)[0]
}

export function truncateNumber(number) {
  // return Math.trunc(number * 100) / 100
  return toFixed(number, 2)
}

export function convertDateToUTC(date) {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  )
}

export function parseValue(value) {
  if (!value) return null

  return parseFloat(value?.replace(/\./g, '')?.replace(',', '.'))
}

export const hasRole = (requiredRoleName = '', role = []) => {
  const findedRole = role?.find(r => r?.name == requiredRoleName)

  return findedRole ? true : false
}

export const getPercentageOf = (value, total) => {
  if (new Decimal(total).equals(0)) return new Decimal(0).toNumber()
  return new Decimal(value).dividedBy(total).times(100).toNumber()
}

export const getPercetageApplicated = (original, final) => {
  const originalDecimal = new Decimal(original)
  const finalDecimal = new Decimal(final)

  if (originalDecimal.equals(0)) return originalDecimal.toNumber()

  return originalDecimal
    .minus(finalDecimal)
    .div(originalDecimal)
    .times(100)
    .toNumber()
}

export const getPercentValue = (percent, value) => {
  if (!percent) return 0
  return new Decimal(percent).div(100).times(value).toNumber()
}

export const useQueryParams = (search = '') => {
  const searchParams = new URLSearchParams(search)
  return Object.fromEntries(searchParams?.entries())
}
